import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PromoBanner } from '../components/PromoBanner';
import { GallerySection } from '../components/GallerySection';
import { BookingCTA } from '../components/BookingCTA';
export function HomePage() {
  return <>
      <HeroSection data-id="element-360" />
      <AboutSection condensed data-id="element-361" />
      <PromoBanner data-id="element-362" />
      <GallerySection data-id="element-363" />
      <BookingCTA data-id="element-364" />
    </>;
}